<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-dark m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div class="col-md-6 text-center mx-auto text-white p-b-30">
              <div class="m-b-10">
                <div class="avatar">
                  <!-- <div class="avatar-title rounded-circle fe fe-briefcase"></div> -->
                </div>
              </div>
              <h3 class="h4">{{ transfers.total }} Transfer Requests</h3>
            </div>
          </div>
        </div>
      </div>

      <section>
        <div class="container">
          <!-- ── Change of facility analytics (agency staff) ── -->
          <CofAnalytics v-if="isAgencyStaff" />
          <div class="col-md-12 card">
            <div class="card-header"></div>

            <div class="card-body">
              <button
                class="btn btn-outline-info spacer-side"
                @click="getPending"
              >
                Pending
              </button>
              <button
                class="btn btn-outline-success spacer-side"
                @click="getApproved"
                v-if="user.user_role != '0'"
              >
                Approved
              </button>
              <button
                class="btn btn-outline-danger spacer-side"
                @click="getRejected"
                v-if="user.user_role != '0'"
              >
                Rejected
              </button>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-md-12">
              <div class="card">
                <div class="card card-header">
                  <p class="h4">
                    <!-- Request(s) -->
                    <i class="mdi mdi-bank-transfer"></i>
                  </p>
                </div>
                <div class="card card-body">
                  <div class="table-responsive">
                    <table class="table align-td-middle table-card">
                      <thead>
                        <tr>
                          <!-- <th>Date</th> -->
                          <th>Patient Name</th>
                          <th>Current facility</th>
                          <th>Proposed (New) Facility</th>
                          <th>Reason for Change</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="trf in transfers.data" v-bind:key="trf.id">
                          <td>
                            <span v-if="trf.client != null">
                              {{ trf.client.firstname }}
                              {{ trf.client.lastname }}
                            </span>
                          </td>
                          <td> <span v-if="trf.oldfacility != null">{{ trf.oldfacility.agency_name }}</span></td>
                          <td> <span v-if="trf.newfacility != null">{{ trf.newfacility.agency_name }}</span></td>
                          <td>
                            {{ trf.reason_for_change }}
                          </td>

                          <td>
                            <span v-if="trf.status == 'approved'">
                              <button
                                type="button"
                                class="btn m-b-15 ml-2 mr-2 badge badge-soft-success"
                              >
                                approved
                              </button>
                            </span>
                            <span v-if="trf.status == 'declined'">
                              <button
                                type="button"
                                class="btn m-b-15 ml-2 mr-2 badge badge-soft-danger"
                              >
                                declined
                              </button>
                            </span>
                            <span v-if="trf.status == 'created'">
                              <button
                                type="button"
                                class="btn m-b-15 ml-2 mr-2 badge badge-soft-warning"
                              >
                                pending
                              </button>
                            </span>
                          </td>
                          <td>
                            <div class="btn-group CTAs" v-if="canDecide">
                              <button
                                type="button"
                                class="btn btn-outline-primary dropdown-toggle m-1"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                <i class="fe fe-edit"></i>
                              </button>
                              <div class="dropdown-menu">
                                <button
                                  class="btn btn-success"
                                  href="#"
                                  @click="updateRequestA(trf)"
                                >
                                  Approve
                                  <i class="fe fe-check"></i>
                                </button>
                                <div class="dropdown-divider"></div>
                                <button
                                  class="btn btn-danger"
                                  href="#"
                                  @click="updateRequestR(trf)"
                                >
                                  Decline
                                  <i class="fe fe-x"></i>
                                </button>
                                <!-- <div class="dropdown-divider"></div> -->
                                <!-- <a
                                class="dropdown-item"
                                href="#"
                                @click="updateprice_vet = true"
                                v-if="
                                  user.type == 'tpa' ||
                                    user.type == 'tpa_employee'
                                "
                                >update price</a
                              >
                              <div class="dropdown-divider"></div>
                              <a
                                class="dropdown-item"
                                href="#"
                                v-if="
                                  user.type == 'shis' || user.type == 'employee'
                                "
                                @click="updateprice_ver = true"
                                >update price</a
                              >
                              <div class="dropdown-divider"></div>
                              <a class="dropdown-item text-info" href="#"
                                >click as applicable</a
                              > -->
                              </div>

                              <button
                                class="btn btn-outline-dark m-1"
                                data-toggle="modal"
                                data-target="#slideRightModalAll"
                                @click="getRequest(trf)"
                              >
                                <i class="fe fe-eye"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="col-md-12">
                    <span class="pagination__CTAs">
                      <button
                        class="btn btn-primary next__page"
                        @click="DecreamentPage"
                      >
                        Previous page
                      </button>
                      <p class="currentPage">{{ pageNum }}</p>
                      <button
                        class="btn btn-primary previous__page"
                        @click="IncreamentPage"
                      >
                        Next page
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Modal -->
            <div
              class="modal fade modal-slide-right"
              id="slideRightModalAll"
              tabindex="-1"
              role="dialog"
              aria-labelledby="slideRightModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content" id="printDiv" ref="printNow">
                  <div class="modal-header" v-if="single_request">
                    <p class="modal-title" id="slideRightModalLabel">
                      <span class="h5">Change of Facility Request</span>

                      <button
                        v-if="single_request.status == 'approved'"
                        type="button"
                        class="btn mx-2 badge badge-soft-info"
                      >
                        approved
                      </button>

                      <button
                        v-if="single_request.status == 'declined'"
                        type="button"
                        class="btn mx-2 badge badge-soft-danger"
                      >
                        declined
                      </button>

                      <button
                        v-if="single_request.status == 'created'"
                        type="button"
                        class="btn mx-2 badge badge-soft-warning spacer"
                      >
                        pending
                      </button>
                    </p>

                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div class="modal-body" v-if="single_request">
                    <div class="">
                      <p class="my-2">
                        <b>Enrollee Name</b>
                        {{ single_request.client.full_name }} (
                        {{ single_request.client.id_card_number }})
                      </p>

                      <p class="my-2">
                        <b>Enrollee Programme</b>
                        {{ single_request.client.sector }}
                      </p>

                      <p class="my-2">
                        <b> Current Facility </b>
                      <span v-if="single_request.oldfacility != null">{{ single_request.oldfacility.agency_name }}</span>
                      </p>
                      <p class="my-2">
                        <b> Requested Facility</b>
                      <span v-if="single_request.newfacility != null">{{ single_request.newfacility.agency_name }}</span>
                      </p>

                      <p class="my-2">
                       <b> Reason for Change</b>
                        {{ single_request.reason_for_change }}
                      </p>

                      <p class="my-2">
                        <b> Date Requested</b>
                        {{
                          single_request.created_at
                            | moment("dddd, MMMM Do YYYY, h:mm:ss a")
                        }}
                      </p>
                    </div>
                    <div class="col-md-12 my-2">
                     

                      <div class="card bg-default">
                        <div class="card-header">
                          <p class="h6">History {{ history.length }}</p>
                        </div>
                        <div
                          class="card-body"
                          v-for="hist in history"
                          v-bind:key="hist.id"
                        >
                          <p class="">
                            <span class="text-xs">
                              {{
                                hist.created_at | moment("dddd, MMMM Do YYYY")
                              }}
                            </span>

                            <button
                              type="button"
                              class="btn mx-2 badge badge-soft-dark"
                            >
                              {{ hist.status }}
                            </button>

                            <button
                            v-if="hist.oldfacility != null"
                              type="button"
                              class="btn m-b-15 m-2 badge badge-soft-danger"
                            >
                              {{ hist.oldfacility.agency_name }}
                            </button>

                            <button
                            v-if="hist.newfacility != null"
                              type="button"
                              class="btn m-b-15 m-2 badge badge-soft-success"
                            >
                              {{ hist.newfacility.agency_name }}
                            </button>
                          </p>
                          <hr />
                        </div>
                      </div>
                    </div>
                    <div class="container">
                      <div class="row">
                        <div class="col-md-12 m-b-30">
                          <div class="card">
                            <div class="card-header border-bottom"></div>

                            <div class="card-footer row"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <div class="row col-md-12" v-if="single_request">
                      <div class="col-md-6">
                        <button
                          v-if="
                            canDecide &&
                            ((single_request.status != 'approved' &&
                              user.type == 'employee') ||
                            user.type == 'shis')
                          "
                          class="btn btn-success btn-block"
                          @click="generateCode(single_request)"
                        >
                          Approve
                        </button>
                      </div>

                      <div class="col-md-6">
                        <button
                          v-if="
                            canDecide &&
                            single_request.status != 'approved' &&
                            single_request.status != 'rejected' &&
                            (user.type == 'employee' || user.type == 'shis')
                          "
                          class="btn btn-danger btn-block"
                          @click="rejectRef(single_request)"
                        >
                          Decline
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--End of Modal -->
          </div>
        </div>
      </section>
    </main>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        loader="dots"
        :can-cancel="true"
        :is-full-page="fullPage"
      ></loading>
    </div>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import CofAnalytics from "@/views/analytics/components/CofAnalytics.vue";
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import { chatContextMixin, focusId } from "@/chat/pageContext";
import { canDecideChangeOfFacility } from "@/utils/changeFacilityAccess";

export default {
  components: { CofAnalytics,
    Navbar,
    Loading,
  },
  mixins: [chatContextMixin],
  data() {
    return {
      isAgencyStaff: ["shis", "employee"].includes((JSON.parse(localStorage.getItem("user") || "{}") || {}).type),
      // editor: ClassicEditor,
      user: null,
      search_result: "",
      enrollee_details: "",
      searchkey: "",
      transfers: "",
      history: "",
      status: "created",
      single_request: null,
      pageNum: 1,
      edit: false,
      isLoading: false,
      show: false,
      fullPage: true,
      transfer: {
        reason_for_change: "",
        client_id: "",
        new_health_facility: "",
        previous_health_facility: "",
        status: "",
        prepared_by: "",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  computed: {
    // enrolment officers prepare requests but don't approve them (the API refuses too)
    canDecide() {
      return canDecideChangeOfFacility(this.user);
    },
  },
  methods: {
    getPending() {
      this.status = "created";
      this.AllTransfers();
    },
    getApproved() {
      this.status = "approved";
      this.AllTransfers();
    },
    getRejected() {
      this.status = "declined";
      this.AllTransfers();
    },

    // getRequest(trt) {
    //   this.single_request =trt;
    // },
    getRequest(trf) {
      this.setChatContext("change_provider", trf.id, "#slideRightModalAll");
      this.isLoading = true;
      this.card_style = "col-md-8";
      this.axios
        .get(`/api/v1/auth/change_providers/${trf.id}`)
        .then((response) => {
          console.log(response);
          this.single_request = response.data.data;
          this.history = response.data.history;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
        });
    },
    updateRequestA(trf) {
      if (confirm("Are you sure you want to approve this request")) {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/change_providers/update/${trf.id}`, {
            status: "approved",
          })
          .then((response) => {
            console.log(response);
            this.AllTransfers();
            this.$toasted.success("Updated Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.isLoading = false;
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
          });
      }
    },
    updateRequestR(trf) {
      if (confirm("Are you sure you want to reject?")) {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/change_providers/update/${trf.id}`, {
            status: "declined",
          })
          .then((response) => {
            console.log(response);
            this.AllTransfers();
            this.isLoading = false;
            this.$toasted.success("Updated Successfully", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
          });
      }
    },

    AllTransfers() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(
          `/api/v1/auth/all/change_providers/407465?page=${this.pageNum}&status=${this.status}`
        )
        .then((response) => {
          this.transfers = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    IncreamentPage() {
      this.pageNum = this.pageNum + 1;
      this.AllTransfers();
    },
    DecreamentPage() {
      if (this.pageNum > 1) {
        this.pageNum = this.pageNum - 1;
        this.AllTransfers();
      }
    },
  },
  created() {
    this.AllTransfers();
  },
  mounted() {
    // Opened from a chat tag (/change-facility-requests?focus=<id>): show that request.
    const id = focusId(this.$route);
    if (id && window.jQuery) {
      this.getRequest({ id });
      window.jQuery("#slideRightModalAll").modal("show");
    }
  },
};
</script>

<style scoped>
.pagination__CTAs {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.currentPage {
  margin: 0 2rem;
  font-weight: 600;
}

.dropdown-menu {
  padding: 1rem;
}
.spacer-side {
  margin-left: 3px;
  margin-right: 3px;
}
</style>
